export const CategorySelect = 'CategorySelect'
export const CategorySelectBegin = 'CategorySelectBegin'
export const CategorySelectClick = 'CategorySelectClick'
